// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2o8Ir","title":"InfoRow_title__1gTOk"};